<script>
import {
  pageCommanderCreationCompteProps,
  usePageCommanderCreationCompte
} from "./mixin";
import InscriptionForm from "@/containers/compte-client/inscription-form";
import ErreurCreationCarteFidelite from "@/components/organisms/erreur-creation-carte-fidelite";
import Popin from "@/components/molecules/popin";

export default {
  components: {
    InscriptionForm,
    ErreurCreationCarteFidelite,
    Popin
  },
  props: {
    ...pageCommanderCreationCompteProps()
  },
  setup() {
    const erreurCreationCarte = ref(null);
    const {
      carteDejaExistante,
      handleAccountCreated,
      redirectToCommander,
      redirectToSuccess,
      mounted
    } = usePageCommanderCreationCompte(erreurCreationCarte);

    onMounted(mounted);

    return {
      carteDejaExistante,
      handleAccountCreated,
      redirectToCommander,
      redirectToSuccess,
      erreurCreationCarte
    };
  },
  methods: {
    redirectToConnexion() {
      navigateToInternal("/commander/connexion");
    }
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
    class="u-bgcolor-white"
  >
    <InscriptionForm
      :is-in-tunnel="isInTunnel"
      @accountCreated="handleAccountCreated"
      @showAuth="redirectToConnexion()"
      @magasinSwitched="redirectToSuccess"
    />
    <Popin
      ref="erreurCreationCarte"
      slide-up
      @cancelled="redirectToCommander"
    >
      <ErreurCreationCarteFidelite :carte-deja-existante="carteDejaExistante" />
    </Popin>
  </div>
</template>
